import React, { useEffect, useState } from "react";

const InstallButtonPWA = ({
  userName,
  buttonLabel = "Install App",
  // handleContinue,
}) => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      window.localStorage.setItem("deferredPrompt", JSON.stringify(e));
      setDeferredPrompt(e);
      setIsVisible(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    const storedPrompt = JSON.parse(
      window.localStorage.getItem("deferredPrompt")
    );
    if (storedPrompt) {
      setDeferredPrompt(storedPrompt);
      setIsVisible(true);
    }

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    if (!deferredPrompt) return;

    deferredPrompt?.prompt();
    deferredPrompt?.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        console.log("User accepted the install prompt");
      } else {
        console.log("User dismissed the install prompt");
      }
      setDeferredPrompt(null);
      setIsVisible(false);
      window.localStorage.removeItem("deferredPrompt");
    });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={handleClick}
      disabled={!userName}
      className={` btn btn-warning rounded-pill noSpace ${
        !userName ? "btn-disabled" : ""
      }`}
    >
      <span className="verticalAlign material-symbols-outlined d-none d-md-inline">
        install_desktop
      </span>
      <span className="verticalAlign material-symbols-outlined d-inline d-md-none">
        install_mobile
      </span>
      <span className="verticalAlign ms-2 pwa-btn">{buttonLabel}</span>
    </button>
  );
};

export default InstallButtonPWA;
